import { ItineraryStop, ItineraryVersion } from 'core/graphql/types';
import { useMemo } from 'react';

type ItineraryPolyline = {
  itineraryPolyline: GeoJSON.Feature<GeoJSON.Geometry>;
};

const useItineraryPolyline = (
  itinerary: ItineraryVersion | undefined,
): ItineraryPolyline => {
  const stopsCoordinates = useMemo(() => {
    const coordinates: number[][] = [];

    if (!itinerary) {
      return coordinates;
    }

    if (itinerary.startLatitude && itinerary.startLongitude) {
      coordinates.push([itinerary.startLongitude, itinerary.startLatitude]);
    }

    const mixedArray: ItineraryStop[] = itinerary.itineraryStops;
    mixedArray
      .filter((stop: ItineraryStop) => stop.longitude && stop.latitude)
      .forEach((x: ItineraryStop) =>
        coordinates.push([x.longitude!, x.latitude!]),
      );

    if (itinerary.endLatitude && itinerary.endLongitude) {
      coordinates.push([itinerary.endLongitude, itinerary.endLatitude]);
    }

    return coordinates;
  }, [itinerary]);

  const itineraryPolyline: GeoJSON.Feature<GeoJSON.Geometry> = {
    id: 'route',
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'LineString',
      coordinates: stopsCoordinates,
    },
  };

  return { itineraryPolyline };
};

export default useItineraryPolyline;
